import React, { useContext, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../config';
import toast from 'react-hot-toast';
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { ApiContext } from '../../UseContext/ApiCall';


const CreateNewPostPopup = () => {

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyAvczQH2_uIOGDXy2pRIpCUiDUnRd_OU60',
    libraries: ['places'],
  });
  
  const {
    loggedInUser,

    // ----- Create New Post -----
    showCreateNewPostPopup, setShowCreateNewPostPopup,
    setCnpPreviouslyOpenedPopup,
    createNewPost,

    // ----- Create New Post > Feeling/Activity -----
    setShowCnpFeelingActivityPopup,
    setCnpFeelingActivityTab,
    cnpSelectedFeeling,
    cnpSelectedActivityCategory,
    cnpSelectedActivity,
    getFeelings, getActivities,

    // ----- Create New Post > Tag -----
    // showCnpTagPopup, setShowCnpTagPopup,
    // setCnpTagAxis,

    // ----- Create New Post > Check in/Location -----
    setShowCnpLocationPopup,
    cnpSelectedLocation, setCnpSelectedLocation,

    // ----- Create New Post > Text -----
    cnpText, setCnpText,

    // ----- Create New Post > Text Background -----

    cnpSelectedTextBackground, setCnpSelectedTextBackground,
    showSelectTextBackground, setShowSelectTextBackground,

    // ----- Create New Post > Music -----
    setShowCnpSelectMusicPopup,
    cnpMusics,
    cnpSelectedMusic, setCnpSelectedMusic,
    selectedMusicPlaying, setSelectedMusicPlaying,
    getMusics,

    // ----- Create New Post > Camera -----
    setShowCnpCameraPopup,

    // ----- Create New Post > Photo/Video -----
    setShowCnpPhotoVideoPopup,
    cnpSelectedPhotoVideo, setCnpSelectedPhotoVideo,
    getVideoDuration,

    // ----- Meme -----
    setShowCnpMemePopup,

    // ----- Flix -----
    setShowCnpFlixPopup,

    // ----- Bestclip -----
    setShowCnpBestclipPopup,

    // ----- Gif -----
    setShowCnpSelectGifPopup,
    getGifs,

    // ----- Collage -----
    setShowCnpSelectCollagePopup,

    // ----- Advance Setting -----
    setShowCnpAdvanceSettingPopup,
    getCnpAdvanceSetting,

  } = useContext(ApiContext);


    // ----- Camera -----

  // handle click camera
  const handleClickCamera = () => {
    setShowCreateNewPostPopup(false);
    setShowCnpCameraPopup(true);
  };


  // ----- Photo/Video -----

  const photoVideoRef = useRef(null);

  // handle click photo/video
  const handleClickPhotoVideo = () => {
    photoVideoRef.current.click(); 
  };

  // handle photo/video file change
  const handlePhotoVideoFileChange = async (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;
  
    const validFiles = [];
    const errorMessages = [];
  
    for (const file of files) {
      // Check file size (1MB = 1 * 1024 * 1024 bytes)
      if (file.size > 1 * 1024 * 1024) {
        errorMessages.push(`File "${file.name}" is larger than 1MB and will not be added.`);
        continue;
      }
  
      if (file.type.startsWith('video/')) {
        try {
          const duration = await getVideoDuration(file);
          if (duration > 10) {
            errorMessages.push(`Video "${file.name}" is longer than 10 seconds and will not be added.`);
          } else {
            validFiles.push({ file, tags: [] });
          }
        } catch (error) {
          errorMessages.push(`Failed to load video metadata for "${file.name}".`);
        }
      } else {
        // If it's an image
        validFiles.push({ file, tags: [] });
      }
    }
  
    const allEntries = [...validFiles, ...cnpSelectedPhotoVideo];
    const videos = allEntries.filter(entry => entry.file.type.startsWith('video/'));
  
    if (videos.length > 5) {
      errorMessages.push("You can select a maximum of 5 videos.");
    }
  
    if (allEntries.length > 15) {
      errorMessages.push("You can select a maximum of 15 files in total (images + videos).");
    }
  
    if (errorMessages.length > 0) {
      alert(errorMessages.join('\n'));
      return;
    }
  
    // Set valid files if no errors
    setCnpSelectedPhotoVideo(allEntries);
  
    // Show popups
    setShowCreateNewPostPopup(false);
    setShowCnpPhotoVideoPopup(true);
    setCnpPreviouslyOpenedPopup('photoVideo');
  };
  


  // ----- Meme -----

  const memeRef = useRef(null);

  // handle click meme
  const handleClickMeme = () => {
    memeRef.current.click(); 
  };

  // handle meme file change
  const handleMemeFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    const file = files[0];

    // console.log('file : ', file);

    setCnpSelectedPhotoVideo([{
      file,
      tags: [],
      fileType: file.type.startsWith('image/') ? 'image' : 'video',
    }]);

    setShowCreateNewPostPopup(false);
    setShowCnpMemePopup(true);
    setCnpPreviouslyOpenedPopup('meme');
  };


  // ----- Flix -----

  const flixRef = useRef(null);

  // handle click flix
  const handleClickFlix = () => {
    flixRef.current.click(); 
  };

  // handle flix file change
  const handleFlixFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    const file = files[0];

    // console.log('file : ', file);

    setCnpSelectedPhotoVideo([{
      file,
      tags: [],
      fileType: file.type.startsWith('image/') ? 'image' : 'video',
    }]);

    setShowCreateNewPostPopup(false);
    setShowCnpFlixPopup(true);
    setCnpPreviouslyOpenedPopup('flix');
  };


  // ----- Bestclip -----

  const bestclipRef = useRef(null);

  // handle click bestclip
  const handleClickBestclip = () => {
    bestclipRef.current.click(); 
  };

  // handle bestclip file change
  const handleBestclipFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    const file = files[0];

    // console.log('file : ', file);

    setCnpSelectedPhotoVideo([{
      file,
      tags: [],
      fileType: file.type.startsWith('image/') ? 'image' : 'video',
    }]);

    setShowCreateNewPostPopup(false);
    setShowCnpBestclipPopup(true);
    setCnpPreviouslyOpenedPopup('bestclip');
  };


  // ----- Gif -----

  // handle click gif
  const handleClickGif = () => {
    setShowCreateNewPostPopup(false);
    setShowCnpSelectGifPopup(true);
    getGifs('');
  };


  // ----- Collage -----

  // handle click collage
  const handleClickCollage = () => {
    setShowCreateNewPostPopup(false);
    setShowCnpSelectCollagePopup(true);
  };


  // ----- Felling/Activity -----

  // handle click feeling/activity
  const handleClickFeelingActivity = () => {
    setShowCnpFeelingActivityPopup(true);
    setShowCreateNewPostPopup(false);
    
    if(cnpSelectedActivityCategory._id) {
      setCnpFeelingActivityTab('activity');

      getActivities(cnpSelectedActivityCategory._id, '', 0);
    } else {
      setCnpFeelingActivityTab('feeling');

      getFeelings('', 0);
    };
  };


  // ----- Check in/Location -----

  // handle click location
  const handleClickLocation = () => {
    setShowCreateNewPostPopup(false);
    setShowCnpLocationPopup(true);
  };


  // ----- Music -----

  const musicRef = useRef(new Audio());

  // handle click music
  const handleClickMusic = () => {
    setShowCnpSelectMusicPopup(true);
    setShowCreateNewPostPopup(false);

    getMusics('', cnpMusics.length, 10);

    musicRef.current.pause();

    setSelectedMusicPlaying(false);
  };

  // handle play/pause music
  const handlePlayPauseMusic = () => {
    if (selectedMusicPlaying) {
      musicRef.current.pause();
      setSelectedMusicPlaying(false);
    } else {
      musicRef.current.src = cnpSelectedMusic.audio;
      musicRef.current.play();
      setSelectedMusicPlaying(true);
    };
  };

  // handle remove music
  const handleRemoveMusic = () => {
    setCnpSelectedMusic({});

    musicRef.current.pause();

    setSelectedMusicPlaying(false);

    // show location image if location selected when user remove music
    if((cnpSelectedTextBackground === '') && (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };


  // ----- Text -----

  // handle textarea text change
  const handleTextChange = (e) => {
    const { value } = e.target; 
  
    if(cnpSelectedTextBackground !== '' && value.length >= 50) {
      alert('You can`t add more text.')
    } else {
      setCnpText(value);
    };
  };


  // ----- Background -----

  // handle click background
  const handleClickBackground = () => {
    setShowSelectTextBackground(!showSelectTextBackground);
  };

  // handle select background
  const handleSelectBackground = (value) => {

    // Text
    if (cnpText.length >= 50) {  
      return toast("You can't select a background, text is too long!");
    };

    // Location
    if (cnpSelectedLocation.placeImage) {      
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: false
      }));
    };

    // Music
    if (cnpSelectedMusic.musicImage) {           
      setCnpSelectedMusic(preState => ({
        ...preState,
        musicImage: false
      }));
    };  

    // Text Background
    setCnpSelectedTextBackground(value);
  };

  // handle remove background
  const handleRemoveBackground = () => {
    setCnpSelectedTextBackground('');

    if(cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '') {     // Music
      setCnpSelectedMusic(preState => ({
        ...preState,
        musicImage: true
      }));
    } else if (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null) {     // Location
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };


  // text background
  const backgrounds = [
    `https://s3aws.emilo.in/images/create-bg-1.jpg`,
    `https://s3aws.emilo.in/images/create-bg-2.jpg`,
    `https://s3aws.emilo.in/images/create-bg-3.jpg`,
    `https://s3aws.emilo.in/images/create-bg-4.jpg`,
    `https://s3aws.emilo.in/images/create-bg-5.jpg`,
    `https://s3aws.emilo.in/images/create-bg-6.jpg`,
    `https://s3aws.emilo.in/images/create-bg-7.jpg`,
    `https://s3aws.emilo.in/images/create-bg-8.jpg`,
    `https://s3aws.emilo.in/images/create-bg-9.jpg`,
  ];

  
  // ----- Tag -----

  // handle click tag
  // const handleClickTag = () => {
  //   setShowCreateNewPostPopup(false);
  //   setShowCnpTagPopup(true);
  // };
  

  // handle create new post 
  const handleCreateNewPost = () => {

    let postType = '';

    if (cnpSelectedTextBackground !== '' && cnpText !== '') {     // Background
      postType = 'textWithBackground';
    } else if (cnpSelectedMusic.id && cnpSelectedMusic.id !== '') {     // Music
      postType = 'music';
    } else if (cnpSelectedLocation.placeImage === true && cnpSelectedLocation.place && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null) {     // Location (image)
      postType = 'location';
    } else if (cnpSelectedLocation.placeImage === false && cnpSelectedLocation.place && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null && cnpText === '') {     // Location
      postType = 'location';
    } else if (cnpSelectedFeeling._id && cnpSelectedFeeling._id !== '' && cnpText === '') {     // Feeling
      postType = 'feeling';
    } else if (cnpSelectedActivity._id && cnpSelectedActivity._id !== '' && cnpText === '') {     // Activity
      postType = 'activity';
    } else if (cnpText !== '') {     // Text
      postType = 'text';
    }

    // console.log('postType : ', postType);

    createNewPost(postType);
  };

  // handle click advance setting
  const handleClickAdvanceSetting = () => {
    setShowCreateNewPostPopup(false);
    setShowCnpAdvanceSettingPopup(true);
    getCnpAdvanceSetting('photoVideo');
  };  

  // handle close create new post popup
  const handleCloseCreateNewPostPopup = () => {
    setShowCreateNewPostPopup(false);
  };
  
  if (!isLoaded) return <div>Loading...</div>;


  // console.log('cnpSelectedMusic : ', cnpSelectedMusic);


  return (
    <>
      <Modal show={showCreateNewPostPopup} onHide={handleCloseCreateNewPostPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={() => setShowCreateNewPostPopup(false)} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='mb-3 pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3'>Create New Post</h5>
        </Modal.Header>

        <Modal.Body>
          {/* Profile, Name, Feeling, Activity & Check in/Location */}
          <>
            {
              loggedInUser 
              &&
              <div className='d-flex align-items-center gap-3'>
                {/* Profile */}
                <img src={loggedInUser.profileImg && loggedInUser.profileImg.imageId && AwsFileUrl+loggedInUser.profileImg.imageId} className='border rounded-circle' style={{ height: '45px', width: '45px' }} alt='profile' />

                <div>
                  {/* Name, Feeling, Activity & Check in/Location */}
                  <div>
                    {/* Name */}
                    <span className='fs-5'>{loggedInUser.fname} {loggedInUser.lname}</span> {' '}

                    {/* Feeling */}
                    <>
                      {
                        (cnpSelectedFeeling && cnpSelectedFeeling._id)
                        &&
                        <>
                          <span className='text-secondary'>is</span> {' feeling '}
                          {cnpSelectedFeeling.feelingName} {' '}
                          <img src={cnpSelectedFeeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                          {' '}
                        </>
                      }
                    </>

                    {/* Activity */}
                    <>
                      {
                        (cnpSelectedActivityCategory && cnpSelectedActivityCategory._id)
                        &&
                        (cnpSelectedActivity && cnpSelectedActivity._id)
                        &&
                        <>
                          <span className='text-secondary'>is</span> {' '}
                          {cnpSelectedActivityCategory.activityCategoryName} {' '}
                          <img src={cnpSelectedActivityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                          {cnpSelectedActivity.activityName} {' '}
                          <img src={cnpSelectedActivity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                        </>
                      }
                    </>

                    {/* Check in/Location */}
                    <>
                      {
                        (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)
                        &&
                        <>
                          <span className='text-secondary'>at</span> {' '}
                          {cnpSelectedLocation.place.split(" ").slice(0, 5).join(" ")}
                          {cnpSelectedLocation.place.split(" ").length > 5 && "..."}
                        </>
                      }
                    </>
                  </div>

                  {/* Add Location */}
                  <>
                    {
                      (cnpSelectedLocation.place === '' && cnpSelectedLocation.lat === null && cnpSelectedLocation.lng === null)
                      &&
                      <div className='cursor-pointer' onClick={handleClickLocation}>
                        <img src={`/images/icons/location-black.svg`} className='me-1' style={{ height: '15px', width: '15px' }} alt="location" />
                        <span>Add Location</span>
                      </div>
                    }
                  </>
                </div>
              </div>
            }
          </>

          {/* Check in/Location image and text/description */}
          <>
            {
              cnpSelectedLocation.placeImage
              &&
              <div className='my-3 position-relative rounded-4'>  
                <span className="position-absolute border rounded-circle bg-light px-2 pt-1 cursor-pointer shadow-sm" style={{ top: "10px", right: "10px", zIndex: 10 }}
                  onClick={() => setCnpSelectedLocation((preState) => ({ ...preState, placeImage: false }))}
                >✖</span>

                <GoogleMap
                  center={{ lat: parseFloat(cnpSelectedLocation.lat), lng: parseFloat(cnpSelectedLocation.lng) }}
                  mapContainerStyle={{ height: "175px", width: "100%", borderRadius: '8px' }}
                  zoom={15}
                  options={{ 
                    mapTypeId: "satellite",
                    fullscreenControl: false, 
                  }}
                >
                  <Marker position={{ lat: parseFloat(cnpSelectedLocation.lat), lng: parseFloat(cnpSelectedLocation.lng) }} />
                </GoogleMap>
              </div>
            }
          </>

          {/* Music image */}
          <>
            {
              (cnpSelectedMusic && cnpSelectedMusic.musicImage)
              &&
              <div className='border rounded-4 my-3 bg-light text-center'>
                <div className='position-relative cursor-pointer d-inline-block'>
                  <img src={cnpSelectedMusic.image} style={{ height: '175px' }} onClick={handlePlayPauseMusic} alt="music" />

                  {/* Remove */}
                  <span className="position-absolute border rounded-circle bg-light px-1 shadow-sm top-0 end-0 mt-2 me-2" style={{ zIndex: 0, fontSize: '12px' }}
                    onClick={handleRemoveMusic}
                  >✖</span>

                  {/* Play/Pause */}
                  <img
                    src={`/images/icons/${selectedMusicPlaying ? 'pause' : 'play'}-circle.svg`}
                    alt={selectedMusicPlaying ? "pause" : "play"}
                    className="position-absolute top-0 start-0 ms-2 mt-2 bg-white rounded-circle"
                    style={{ height: '23px', width: '23px' }}
                    onClick={handlePlayPauseMusic}
                  />
                </div>
              </div>
            }
          </>

          {/* Text with background (Div and textarea for text with background post) */}
          <>
            {
              (cnpSelectedTextBackground !== '')
              &&
              <div className='position-relative my-3' style={{ height: "265px", width: "100%" }}>
                {/* Background Layer */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: cnpSelectedTextBackground ? `url('${cnpSelectedTextBackground}')` : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    borderRadius: "8px",
                  }}
                />
                
                {/* Textarea Layer */}
                <textarea className="form-control shadow-none border-0" rows={5} name="text" placeholder={`What's new ${loggedInUser && loggedInUser.fname}..?`}
                  value={cnpText} onChange={handleTextChange}
                  style={{
                    resize: "none",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "transparent", // Transparent to show the background
                    color: "white",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    paddingTop: "130px", // Push text down to center
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    boxSizing: "border-box",
                    borderRadius: "8px",
                    position: "relative",
                    zIndex: 2, // Ensure text is above the background
                  }}
                />
              </div>
            }
          </>

          {/* Music text (jb music selected h lekin music image show nhi krna h tb ye show krna h) */}
          <>
            {
              (cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '')
              &&
              <div className='my-3 d-flex align-items-center gap-3'>
                <img src="/images/icons/music.svg" style={{ height: '17px', width: '17px' }} alt="music" />

                <span className='me-auto text-truncate'>{cnpSelectedMusic.name}</span>

                {/* Play/Pause */}
                <img src={selectedMusicPlaying ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} 
                  className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handlePlayPauseMusic} alt='playPause'
                />

                {/* Remove */}
                <img src="/images/icons/close-circle.svg" className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handleRemoveMusic} alt="remove" />
              </div>
            }
          </>

          {/* Text (Textarea for text post) */}
          <>
            {
              (cnpSelectedTextBackground === '')
              &&
              <textarea className="form-control rounded-4 my-3 shadow-none" name="text" style={{ resize: 'none' }} placeholder={`What's new ${loggedInUser && loggedInUser.fname}..?`}
                value={cnpText} onChange={handleTextChange}
                rows={
                  (
                    (cnpSelectedLocation.placeImage)
                    ||
                    (cnpSelectedMusic && cnpSelectedMusic.musicImage)
                  )
                  ? 3 : 10
                }
              />
            }
          </>

          {/* Select Text Background */}
          <>
            {
              showSelectTextBackground
              &&
              <div className='my-3 d-flex align-items-center gap-2 overflow-x-scroll pb-1'>
                <img src="/images/none.jpg" className={`${cnpSelectedTextBackground === '' && 'border border-primary border-2'} rounded-3 cursor-pointer`} style={{ height: '50px', width: '70px' }} alt="bg" 
                  onClick={handleRemoveBackground} 
                />

                {
                  backgrounds.map((value, index) => (
                    <img src={value} className={`${cnpSelectedTextBackground === value && 'border border-primary border-2'} rounded-3 cursor-pointer`} style={{ height: '50px', width: '70px' }}  alt="bg" key={index}
                      onClick={() => handleSelectBackground(value)} 
                    />
                  ))
                }

                <hr className='hr' />
              </div>
            }
          </>

          {/* Menu */}
          <div className='d-flex flex-wrap gap-4'>
            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickCamera}>
              <img src={`${BASE_URL_STATIC}/create-icon2.png`} style={{ height: '23px', width: '23px' }} alt="Camera" />
              <small className="text-secondary">Camera</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickPhotoVideo}>
              <img src={`${BASE_URL_STATIC}/create-icon3.png`} style={{ height: '23px', width: '23px' }} alt="post" />
              <small className="text-secondary">Photo/Video</small>
              <input type="file" ref={photoVideoRef} style={{ display: 'none' }} accept="image/*,video/*" onChange={handlePhotoVideoFileChange} multiple />
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickMeme}>
              <img src={`${BASE_URL_STATIC}/create-icon4.png`} style={{ height: '23px', width: '23px' }} alt="Memes" />
              <small className="text-secondary">Memes</small>
              <input type="file" ref={memeRef} style={{ display: 'none' }} accept="image/*,video/*" onChange={handleMemeFileChange} />
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickFlix}>
              <img src={`${BASE_URL_STATIC}/create-icon5.png`} style={{ height: '23px', width: '23px' }} alt="Flix" />
              <small className="text-secondary">Flix</small>
              <input type="file" ref={flixRef} style={{ display: 'none' }} accept="video/*" onChange={handleFlixFileChange} />
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickBestclip}>
              <img src={`${BASE_URL_STATIC}/create-icon6.png`} style={{ height: '23px', width: '23px' }} alt="Best Clips" />
              <small className="text-secondary">Best Clips</small>
              <input type="file" ref={bestclipRef} style={{ display: 'none' }} accept="video/*" onChange={handleBestclipFileChange} />
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickCollage}>
              <img src={`${BASE_URL_STATIC}/create-icon13.png`} style={{ height: '23px', width: '23px' }} alt="Collage" />
              <small className="text-secondary">Collage</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickBackground}>
              <img src={`${BASE_URL_STATIC}/create-icon12.png`} style={{ height: '23px', width: '23px' }} alt="Background" />
              <small className="text-secondary">Background</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickGif}>
              <img src={`${BASE_URL_STATIC}/create-icon10.png`} style={{ height: '23px', width: '23px' }} alt="Gif" />
              <small className="text-secondary">Gif</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickFeelingActivity}>
              <img src={`${BASE_URL_STATIC}/create-icon8.png`} style={{ height: '23px', width: '23px' }} alt="feeling/activity" />
              <small className="text-secondary">Feeling/Activity</small>
            </div>

            {/* <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickTag}>
              <img src={`/images/icons/tag-blue.svg`} style={{ height: '23px', width: '23px' }} alt="tag" />
              <small className="text-secondary">Tag</small>
            </div> */}

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickLocation}>
              <img src={`${BASE_URL_STATIC}/create-icon9.png`} style={{ height: '23px', width: '23px' }} alt="Check In" />
              <small className="text-secondary">Check In</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickMusic}>
              <img src={`${BASE_URL_STATIC}/create-icon11.png`} style={{ height: '23px', width: '23px' }} alt="Music" />
              <small className="text-secondary">Music</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer">
              <img src={`${BASE_URL_STATIC}/create-icon7.png`} style={{ height: '23px', width: '23px' }} alt="eShow" />
              <small className="text-secondary">eShow</small>
            </div>
          </div>

          {/* Post */}
          <button type="button" className={`btn btn-primary rounded-pill w-100 mt-4 mb-2`} onClick={handleCreateNewPost}
            disabled={
              (cnpText.trim() === '')     // Text
              &&
              (!cnpSelectedFeeling._id)     // Feeling
              &&
              (!cnpSelectedActivity._id)     // Activity 
              &&
              (cnpSelectedLocation.place === '' && cnpSelectedLocation.lat === null && cnpSelectedLocation.lng === null)     // Location
              &&
              (!cnpSelectedMusic.id)     // Music
            }
          >Post</button>

          {/* Advance Setting */}
          <div className='text-center'>
            <span className='text-primary cursor-pointer' onClick={handleClickAdvanceSetting}>Advance Setting</span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateNewPostPopup;